import type { FunctionComponent } from 'react';

import SidebarNav from '../generic/SidebarNav';

import { defineSlotComponent, findFirstForSlot } from './slots';

import styles from './layouts.module.less';

type SidebarNavLayoutComponent = FunctionComponent & {
  Nav: typeof SidebarNav;
  NavHeading: typeof SidebarNav.Heading;
  NavItem: typeof SidebarNav.Item;
  PaidNavItem: typeof SidebarNav.PaidItem;
  Content: FunctionComponent;
};

/**
 * @example
 * <SidebarNavLayout>
 *  <SidebarNavLayout.Nav>
 *   <SidebarNavLayout.NavHeading>
 *    Settings
 *  </SidebarNavLayout.NavHeading>
 * <SidebarNavLayout.NavItem to="/home" isActive>
 *
 */
const SidebarNavLayout: SidebarNavLayoutComponent = ({ children }) => {
  const nav = findFirstForSlot('nav', children);
  const content = findFirstForSlot('content', children);
  return (
    <div className={styles.sidebarNavLayout}>
      <span className={styles.sidebarNavLayoutNavigation}>
        {nav}
      </span>
      {content}
    </div>
  );
};

SidebarNavLayout.Nav = defineSlotComponent('nav', SidebarNav);
SidebarNavLayout.NavHeading = SidebarNav.Heading;
SidebarNavLayout.NavItem = SidebarNav.Item;
SidebarNavLayout.PaidNavItem = SidebarNav.PaidItem;
SidebarNavLayout.Content = defineSlotComponent('content', ({ children }) => (
  <main className={styles.sidebarNavLayoutContent}>
    {children}
  </main>
));

export default SidebarNavLayout;
